import {
  getCurrentUser,
  isBlocked as getIsBlocked,
  isPrivate as getIsPrivate,
} from '@app/external/common/store/auth/current-user-selectors';
import { useSelector } from '../components/runtime-context';
import { type CurrentUser } from '../store/auth/types';

export type UseAuth = {
  currentUser: CurrentUser | null;
  isAuthenticated: boolean;
  isBlocked?: boolean;
  isPrivate?: boolean;
};

export default function useAuth(): UseAuth {
  const currentUser = useSelector(getCurrentUser);
  const isAuthenticated = !!currentUser;
  const isBlocked = useSelector(getIsBlocked);
  const isPrivate = useSelector(getIsPrivate);

  return {
    currentUser,
    isAuthenticated,
    isBlocked,
    isPrivate,
  };
}
